enum LoaderStatus {
    kIdle,
    kConnecting,
    kBuffering,
    kError,
    kComplete
}

export default LoaderStatus;
